import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Check for both email and mobile verification
  const isEmailVerified = user.isEmailVerified || user.emailVerified || user.email_verified;
  const isMobileVerified = user.isMobileVerified || user.mobileVerified || user.mobile_verified;
  if (!isEmailVerified && !isMobileVerified) {
    // Pass available info for verification page
    const available = {
      email: user.email,
      mobile: user.mobile,
      name: user.name,
    };
    return (
      <Navigate
        to="/verify"
        replace
        state={{ available, identifier: user.email || user.mobile, from: location }}
      />
    );
  }
  return children;
}
